export default "__VITE_ASSET__BkcCdiL7__"